<template>
  <div class="h-full w-full grid place-content-center">
    <div class="flex flex-col justify-items-center">
      <img :src="emptyStateImage" :alt="status"/>
      <p class="text-2xl mt-5 text-center min-w-192" v-html="emptyStateDescription"/>
    </div>
  </div>
</template>

<script>
import answerReportFirstRunImage from '@/assets/images/answer_report_first_run.svg'
import answerReportSuccessImage from '@/assets/images/answer_report_success.svg'
import { REPORT_STATUSES } from '@/store/constants'
import testReportModule from '@/store/modules/test-report.module'

const NEVER_RUN_DESCRIPTION = `The first report will be visible once you promote training intents.
  <br/>
  To do that, hit the <b>"Promote Training Intents"</b> button in the top right corner.`

const ERROR_DESCRIPTION = 'There has been an error during last verification'

const SUCCESS_DESCRIPTION = `The latest example promotion at
  <br/>
  {lastRunDatetime} was successful!`

export default {
  name: 'AnswersReportEmptyStates',

  data() {
    return {
      REPORT_STATUSES
    }
  },

  computed: {
    lastReportDate: testReportModule.getReportLastRunDate,

    status() {
      return testReportModule.getReportStatuses().lastFinishedStatus
    },

    emptyStateImage() {
      return [REPORT_STATUSES.NEVER_RUN, REPORT_STATUSES.ERROR].includes(this.status) ?
        answerReportFirstRunImage :
        answerReportSuccessImage
    },

    emptyStateDescription() {
      const statusDescriptionMap = {
        [REPORT_STATUSES.NEVER_RUN]: NEVER_RUN_DESCRIPTION,
        [REPORT_STATUSES.ERROR]: ERROR_DESCRIPTION
      }
      return statusDescriptionMap[this.status] || SUCCESS_DESCRIPTION.replace('{lastRunDatetime}', this.lastReportDate)
    }
  }
}
</script>
